import get_title from "@/router/module/get_title";
import validate_role from "@/router/module/validate_role";
import createProject from "./detail/create";
import editProject from "./detail/edit";

export default {
  path: "/content/settings/project",
  name: "Settings-Project",
  component: () => import("@/new/pages/settings/project/index.vue"),
  meta: {
    title: get_title("Редактирование проектов"),
    forVisitors: true,
    requiresAuth: true
  },
  beforeEnter: (to, from, next) => {
    const options = {
      role: "settings_project",
      route: { to, from, next },
      callback: false,
      redirectText: "У вас нет доступа к разделу с настройками!",
    };
    validate_role(options);
  },
  children: [createProject, editProject]
};
